import(/* webpackMode: "eager" */ "/var/www/rutavix/frontend/src/app/[locale]/cart/page.tsx");
